var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.353516,
    width: 70,
    height: 70,
    rx: 17.5,
    fill: "#F5B6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 27.7536V27.3536C40.3333 24.4069 37.9466 22.0203 35 22.0203C32.0533 22.0203 29.6666 24.4069 29.6666 27.3536V34.0203",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0533 38.2736C32.0267 39.3536 33.44 40.0203 35 40.0203C37.9467 40.0203 40.3333 37.6336 40.3333 34.6869V34.0203",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.04 41.9533C29.8667 43.6466 32.3067 44.6866 35 44.6866C40.6267 44.6866 45.2 40.1133 45.2 34.4866V32.22",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8002 32.22V34.4866C24.8002 35.9 25.0802 37.2333 25.6002 38.46",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7599 23.1404L24.2399 44.6737",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6666 23.3535V27.3535",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44.6868V48.6868",
    stroke: "#B73A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteMic);
export default __webpack_public_path__ + "static/media/mute-mic.52f19e636adf5f0a7635898dcaf6f066.svg";
export { ForwardRef as ReactComponent };